import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SimSearchVehicle } from 'src/app/api/models';
import { Data } from 'src/app/utils/models/data.interface';

import { simsearchInViewport, simsearchStartLoadVehiclesAction } from './store/simsearch.actions';
import {
  selectSimsearchCurrentVehicle,
  selectSimsearchFootnotes,
  selectSimsearchSimilarVehicles,
  selectSimsearchVehicleId
} from './store/simsearch.selectors';

@Injectable()
export class SimsearchService {
  public constructor(private readonly store: Store) {}

  public get vehicleId$(): Observable<string> {
    return this.store.select(selectSimsearchVehicleId);
  }

  public get vehicleConfiguration$(): Observable<SimSearchVehicle> {
    return this.store.select(selectSimsearchCurrentVehicle);
  }

  public get similarVehicles$(): Observable<SimSearchVehicle[]> {
    // eslint-disable-next-line @ngrx/avoid-mapping-selectors
    return this.store.select(selectSimsearchSimilarVehicles).pipe(map(this.checkForEqualDataAmount));
  }

  public get footnotes$(): Observable<Data> {
    return this.store.select(selectSimsearchFootnotes);
  }

  public startLoadVehiclesAction(vehicleId: string): void {
    this.store.dispatch(simsearchStartLoadVehiclesAction({ payload: { vehicleId } }));
  }

  public callInViewportAction(vehicle: SimSearchVehicle): void {
    this.store.dispatch(simsearchInViewport({ payload: { vehicle } }));
  }

  private checkForEqualDataAmount(simsearchVehicles: SimSearchVehicle[] = []): SimSearchVehicle[] {
    const amountOfDataAsKeys = {};
    simsearchVehicles.forEach(vehicle => {
      amountOfDataAsKeys[vehicle.motorization?.length ?? `${null}`] = 1;
    });

    return Object.keys(amountOfDataAsKeys).length === 1 && !Object.keys(amountOfDataAsKeys).includes(`${null}`)
      ? simsearchVehicles
      : [];
  }
}
